import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import UrlUtils from '../../../utils/url';
import { StyleColor } from '../../../utils/styles-constants';
import UserAgentUtils from '../../../utils/userAgent';
import { StoreState } from '../../../reducers';
import { GalleryInfosState } from '../../Gallery/reducer';
import { DownloadButtonVariants } from './styles';
import { requestWebDownloadItem, requestMobileAppDownload, downloadRecursively, downloadAll } from '../../DownloadManager/actions';
import DownloadManagerUtils from '../../../utils/downloadManager';
import Tooltip from '../../../components/Tooltip';
import { ActionButtonStyle, ActionButton } from '../../../utils/driveItem';
import Loader, { LoaderStep, LoaderType, LoaderStepName } from '../../../components/Loader';
import { DownloadMode } from '../../DownloadManager/reducer';
import StatsUtils from '../../../utils/statistics';
const Translate = require('react-redux-i18n').Translate;

const RESET_DELAY = 3000;

export interface DriveItemDownloadButtonProps {
	driveItems?: Api.DriveItem[];
	dispatch: Dispatch<StoreState>;
	style: ActionButtonStyle;
	action?: ActionButton;
	galleryInfos: GalleryInfosState;
	isDownloading: boolean;
	isDownloadingAll: boolean;
	loaderStep: LoaderStep;
}

interface DownloadButtonContainerProps {
	driveItems?: Api.DriveItem[];
}

export interface DriveItemDownloadButtonState {
	clicked: boolean;
}

class DriveItemDownloadButton extends React.Component<DriveItemDownloadButtonProps, DriveItemDownloadButtonState> {

	constructor(props: DriveItemDownloadButtonProps) {
		super(props);
		this.state = { clicked: false };
		this.handleClick = this.handleClick.bind(this);
		this.renderButtonContent = this.renderButtonContent.bind(this);
	}

	handleClick(e: React.MouseEvent<HTMLDivElement>) {
		e.stopPropagation();

		const { driveItems, dispatch, galleryInfos, action, isDownloadingAll } = this.props;
		const { isMobileApp } = UserAgentUtils;

		if (driveItems) {
			if (action !== ActionButton.Update) {
				StatsUtils.trackDownload(driveItems);
			}
			const driveItemsIds = driveItems.map(driveItem => driveItem.id);

			if (!isMobileApp) {
				this.setState({ clicked: true });
				setTimeout(() => this.setState({ clicked: false }), RESET_DELAY);

				if (driveItems.length === 1) {
					dispatch(requestWebDownloadItem(driveItems[0]));
				} else {
					window.location.href = UrlUtils.getResourcesGroupUrl(galleryInfos.config, driveItemsIds);
				}
			} else {
				if (driveItems.length === 1) {
					dispatch(requestMobileAppDownload(driveItems[0], DownloadMode.Requested));
				} else {
					driveItemsIds.forEach(itemId => {
						dispatch(downloadRecursively(itemId, DownloadMode.Requested));
					});
				}
			}
		} else {
			if (!isDownloadingAll) {
				dispatch(downloadAll());
			}
		}
	}

	renderButtonContent = () => {
		const { style, action, isDownloading, loaderStep, isDownloadingAll } = this.props;
		const isPhone = UserAgentUtils.isPhone();

		if (style === ActionButtonStyle.Bar) {
			if (isDownloading) {
				return <Loader loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }} type={LoaderType.Button} />;
			}
			if (action === ActionButton.Update) {
				return isPhone ? Utils.getSvgIcon('iconset_update') : <Translate value="messages.update" />;
			} else {
				return <Translate value="messages.download" />;
			}
		} else if (style === ActionButtonStyle.Icon) {
			return Utils.getSvgIcon('iconset_download');
		} else if (style === ActionButtonStyle.IconBold) {
			return Utils.getSvgIcon('iconset_download-bold');
		} else if (style === ActionButtonStyle.ParametersPage) {
			if (isDownloadingAll) {
				return <Loader loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }} type={LoaderType.Button} />;
			}
			return <Translate value="messages.download_all" />;
		} else {
			return;
		}
	}

	render () {
		const { action, style, isDownloading, galleryInfos } = this.props;
		const { clicked } = this.state;

		const primary = galleryInfos.template.commonStyles && galleryInfos.template.commonStyles.primary;
		const iconsColor = primary ? primary.iconsColor : StyleColor.Black;
		const isFlickering = isDownloading || clicked;
		const tooltipId = Utils.generateId();
		const DownloadButton = DownloadButtonVariants[style];

		return (
			<DownloadButton
				onClick={this.handleClick}
				isFlickering={isFlickering}
				color={style === ActionButtonStyle.IconBold ? StyleColor.White : iconsColor}
				action={action}
				data-tip={style === ActionButtonStyle.Icon}
				data-for={tooltipId}
			>
				{this.renderButtonContent()}
				{(UserAgentUtils.isDesktop() && style === ActionButtonStyle.Icon) &&
					<Tooltip id={tooltipId} text={'messages.download'} />
				}
			</DownloadButton>
		);
	}
}

const mapStateToProps = (state: StoreState, props: DownloadButtonContainerProps) => {
	const { galleryInfos, downloadManager, driveList } = state;
	const { driveItems } = props;
	const { isDownloadingAll } = downloadManager;
	const galleryId = galleryInfos.config.applicationGallery;
	const isDownloading = driveItems ? DownloadManagerUtils.isItemDownloading(downloadManager, driveItems[0].id) : false;
	const driveItemId = driveItems ? driveItems[0].id : galleryInfos.config.applicationGallery;
	const loaderStep = driveItems
		? DownloadManagerUtils.getItemLoaderStep(downloadManager, driveItemId)
		: DownloadManagerUtils.getGalleryLoaderStep(downloadManager, driveList, galleryId, isDownloadingAll);

	return { galleryInfos, isDownloading, loaderStep, isDownloadingAll };
};

export default connect(mapStateToProps)(DriveItemDownloadButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DownloadButton/index.tsx